import { render, staticRenderFns } from "./EMelderComponentMeldenBs7OrgElemente.vue?vue&type=template&id=354255a6"
import script from "./EMelderComponentMeldenBs7OrgElemente.vue?vue&type=script&lang=js"
export * from "./EMelderComponentMeldenBs7OrgElemente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports